import urls from '../api_urls/appPictures'
import { _post } from '@/axios/request'

// 获取列表
export function getDataListApi (params) {
  return _post(urls.GET_DATA_LIST, params)
}

// 编辑
export function updateDataApi (params) {
  return _post(urls.UPDATE_DATA, params)
}

// 获取详情
export function getDetailApi (params) {
  return _post(urls.GET_DETAIL, params)
}

// 获取brand 下拉
export function getBrandList (params) {
  return _post(urls.GET_BRAND_LIST, params)
}

// 获取concept 下拉
export function getConceptList (params) {
  return _post(urls.GET_CONCETP_LIST, params)
}

// 获取formulation 下拉
export function getFormulationList (params) {
  return _post(urls.GET_FORMULATION_LIST, params)
}

// 获取consumer product 下拉
export function getConsumerProduct (params) {
  return _post(urls.GET_CONSUMER_PRODUCT, params)
}

// 获取event 下拉
export function getEventList (params) {
  return _post(urls.GET_EVENT_LIST, params)
}

//获取basf product 下拉
export function getBasfProduct (params) {
  return _post(urls.GET_BASF_PRODUCT, params)
}

//获取inci 下拉
export function getInci (params) {
  return _post(urls.GET_INCI, params)
}

//获取trend 下拉
export function getTrend (params) {
  return _post(urls.GET_TREND, params)
}

//获取webinar 下拉
export function getWebinar (params) {
  return _post(urls.GET_WEBINAR, params)
}
//修改banner状态
export function changeStatus (params) {
  return _post(urls.CHANGE_STATUS, params)
}
//新增banner
export function addBanner (params) {
  return _post(urls.ADD_BANNER, params)
}
// 验证weight
export function checkWeight (params) {
  return _post(urls.CHECK_WEIGHT, params)
}
// 设置weight
export function setWeight (params) {
  return _post(urls.SET_WEIGHT, params)
}
// 删除web banner
export function delWebBanner (params) {
  return _post(urls.DELETE_WEB_BANNER, params)
}
// 获取 banner 数量
export function getBannerCount (params) {
  return _post(urls.GET_BANNER_COUNT, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/appPictures.js